import { render, staticRenderFns } from "./LabelArchiveContentsBadge.vue?vue&type=template&id=7d6d4504"
import script from "./LabelArchiveContentsBadge.vue?vue&type=script&lang=js"
export * from "./LabelArchiveContentsBadge.vue?vue&type=script&lang=js"
import style0 from "./LabelArchiveContentsBadge.vue?vue&type=style&index=0&id=7d6d4504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports